/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

const TransferGuidelines = [
  "Please ensure that the funds are transferred from the designated / mapped bank account.",
  "Please ensure that correct details are entered before initiating the fund transfer.",
  "Wealthy's virtual bank account is alpha-numeric. Kindly add this account as payees to transfer funds to the WEalthy’s account.",
  "Wealthy does not accept any deposits via cash or Demand Draft (DD)."
];

const PaymentDepositDetails = [
  {
    method: "UPI",
    time: "Instant",
    charges: "Free"
  },
  {
    method: "Virtual Account API",
    time: "Instant",
    charges: "Re.1 + 18% GST"
  },
  {
    method: "NEFT/RTGS (From HDFC to HDFC)",
    time: "Within 4 hours",
    charges: "Rs.6 + 18% GST"
  },
  {
    method: "NEFT/RTGS (From other banks to HDFC Bank)",
    time: "Within 4 hours",
    charges: "Rs.9 + 18% GST"
  },
  {
    method: "IMPS",
    time: "Within 1 hour",
    charges: "Free at Wealthy, bank charges may apply"
  },
  {
    method: "Cheque",
    time: "3 to 5 working days",
    charges: "Free"
  }
];

const BankDepositDetails = [
  {
    title: "Bank Name",
    detail: "HDFC BANK LTD"
  },
  {
    title: "Account Title",
    detail: "WEALTHYIN BROKING PRIVATE LIMITED "
  },
  {
    title: "Account Number",
    detail: "WBPL22 (Followed by Client UCC) For Ex: WBPL22ABC123"
  },
  {
    title: "Account type",
    detail: "Current account"
  },
  {
    title: "Bank Branch",
    detail: "RICHMOND ROAD - BENGALURU, KARNATAKA"
  },
  {
    title: "IFSC Code",
    detail: "HDFC0000523"
  }
];

export {
  TransferGuidelines,
  PaymentDepositDetails,
  BankDepositDetails
};
